import React from 'react';
import './style.scss';

class NewCheckbox extends React.Component {
    constructor(props) {
        super(props);

        this.onCheckboxClick = this.onCheckboxClick.bind(this);
        this.onKeyUpClick = this.onKeyUpClick.bind(this);
    }

    onCheckboxClick() {
        this.props.onchange(this.props.name, this.props.keyId);
    }

    onKeyUpClick(e) {
        if (e.keyCode === 13 || e.keyCode === 32) this.onCheckboxClick();
    }

    onKeyDown(e) {
        if (e.keyCode === 32) e.preventDefault();
    }

    render() {
        let cls = this.props.selected ? ' _selected' : '';
        if (this.props.position === 'right') cls += ' _position-right';
        if (this.props.disabled) cls += ' _disabled';

        return (
            <div 
                tabIndex="0"
                className={'position-relative new-design-checkbox' + cls}
                onKeyUp={this.onKeyUpClick}
                onKeyDown={this.onKeyDown}
                onClick={this.onCheckboxClick}
            >
                <div className="new-design-checkbox-label">{this.props.label}</div>
                <div className="new-design-checkbox-rect"></div>
            </div>
        )
    }
}
export default NewCheckbox;


// WEBPACK FOOTER //
// ./src/components/HTMLelements/NewCheckbox/NewCheckbox.js